var _rect, _defs, _circle, _circle2, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCcMono(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 95,
    viewBox: "0 0 164 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 164,
    height: 95,
    rx: 4,
    fill: "url(#paint0_linear_2244_6140)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2244_6140",
    x1: 26.5,
    y1: 2.99999,
    x2: 114,
    y2: 95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B3B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F1F1F"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49.25,
    cy: 47.9561,
    r: 11.25,
    fill: "#EB001B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.75,
    cy: 47.9561,
    r: 11.25,
    fill: "#F79E1B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.9997 56.956C59.1052 55.1596 61.1947 51.8018 61.1947 47.956C61.1947 44.1103 59.1052 40.7525 55.9997 38.9561C52.8941 40.7525 50.8047 44.1103 50.8047 47.956C50.8047 51.8018 52.8941 55.1596 55.9997 56.956Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.668 42.3925L98.955 53.6365H95.88L93.561 44.662C93.42 44.11 93.2985 43.9075 92.8695 43.675C92.1705 43.2955 91.0155 42.94 90 42.718L90.069 42.3925H95.019C95.3425 42.3922 95.6554 42.5075 95.9013 42.7177C96.1472 42.9278 96.3099 43.219 96.36 43.5385L97.5855 50.0455L100.612 42.3925H103.668ZM115.718 49.966C115.729 46.9975 111.614 46.834 111.642 45.508C111.651 45.1045 112.035 44.6755 112.875 44.566C113.859 44.4726 114.851 44.6467 115.744 45.07L116.255 42.685C115.384 42.358 114.463 42.1888 113.534 42.1855C110.658 42.1855 108.635 43.7155 108.617 45.904C108.599 47.5225 110.061 48.424 111.163 48.964C112.298 49.5145 112.678 49.8685 112.673 50.3605C112.665 51.1165 111.77 51.448 110.932 51.4615C109.47 51.484 108.623 51.067 107.944 50.752L107.418 53.215C108.097 53.527 109.351 53.8 110.652 53.812C113.707 53.812 115.707 52.303 115.718 49.966ZM123.309 53.6365H126L123.653 42.3925H121.168C120.903 42.3901 120.643 42.4674 120.422 42.6145C120.201 42.7616 120.03 42.9717 119.929 43.2175L115.566 53.6365H118.62L119.228 51.9565H122.959L123.309 53.6365ZM120.064 49.6525L121.594 45.43L122.476 49.6525H120.064ZM107.825 42.3925L105.42 53.6365H102.51L104.917 42.3925H107.825Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcMono);
export default __webpack_public_path__ + "static/media/cc-mono.ecf84980de03e20b19492875ecd13a04.svg";
export { ForwardRef as ReactComponent };